import React from 'react';
import './youtubePlayer.scss';

interface YoutubePlayerProps {
  youtubeId: string;
  id?: string;
}

function YoutubePlayer(props: YoutubePlayerProps) {

  return (
    <iframe
      id={props.id}
      className="m-youtube__player"
      src={`https://www.youtube.com/embed/${props.youtubeId}`}
      frameBorder="0"
      allowFullScreen={true}
      allowTransparency={true}
    />)
}

export default YoutubePlayer;